// skills's picture imported
import CIcon from './assets/skills/CIcon';
import JavaIcon from './assets/skills/JavaIcon';
import PythonIcon from './assets/skills/PythonIcon';
import JavaScriptIcon from './assets/skills/JavaScriptIcon';
import TypescriptIcon from './assets/skills/TypescriptIcon';
import NodeIcon from './assets/skills/NodeIcon';
import HTMLIcon from './assets/skills/HTMLIcon';
import CSSIcon from './assets/skills/CSSIcon';
import PhpIcon from './assets/skills/PhpIcon';
import MongoDBIcon from './assets/skills/MongoDBIcon';
import MySQLIcon from './assets/skills/MySQLIcon';
import FirebaseIcon from './assets/skills/FirebaseIcon';
import ReactIcon from './assets/skills/ReactIcon';
import ReactRouterIcon from './assets/skills/ReactRouterIcon';
import CreateReactAppIcon from './assets/skills/CreateReactAppIcon';
import ReactQueryIcon from './assets/skills/ReactQueryIcon';
import ReactHookFormIcon from './assets/skills/ReactHookFormIcon';
import NextJSIcon from './assets/skills/NextJSIcon';
import TailwindCSSIcon from './assets/skills/TailwindCSSIcon';
import DaisyUIIcon from './assets/skills/DaisyUIIcon';
import BootstrapIcon from './assets/skills/BootstrapIcon';
import MaterialUIIcon from './assets/skills/MaterialUIIcon';
import ExpressJSIcon from './assets/skills/ExpressJSIcon';
import JWTIcon from './assets/skills/JWTIcon';
import NpmIcon from './assets/skills/NpmIcon';
import VsCodeIcon from './assets/skills/VsCodeIcon';
import GitIcon from './assets/skills/GitIcon';
import GitHubIcon from './assets/skills/GitHubIcon';
import GitBashIcon from './assets/skills/GitBashIcon';
import FigmaIcon from './assets/skills/FigmaIcon';
import ChromeDevToolsIcon from './assets/skills/ChromeDevToolsIcon';
import FirebaseStorageIcon from './assets/skills/FirebaseStorageIcon';
import NetlifyIcon from './assets/skills/NetlifyIcon';
import HerokuIcon from './assets/skills/HerokuIcon';
import MicrosoftOfficeIcon from './assets/skills/MicrosoftOfficeIcon';
import AdobePhotoshopIcon from './assets/skills/AdobePhotoshopIcon';
import WindowsIcon from './assets/skills/WindowsIcon';
import FlimoraIcon from './assets/skills/FlimoraIcon';
import ReactNativeIcon from './assets/skills/ReactNativeIcon';

// projects's picture imported 
import vertexTools1 from './assets/projectImages/vertexToolsImages/others/Vertex Tools-1.jpg';
import vertexTools2 from './assets/projectImages/vertexToolsImages/others/Vertex Tools-2.jpg';
import vertexTools3 from './assets/projectImages/vertexToolsImages/others/Vertex Tools-3.jpg';
import vertexTools4 from './assets/projectImages/vertexToolsImages/others/Vertex Tools-4.jpg';
import vertexTools5 from './assets/projectImages/vertexToolsImages/others/Vertex Tools-5.jpg';
import vertexTools6 from './assets/projectImages/vertexToolsImages/others/Vertex Tools-6.jpg';
import primaxElectronics1 from './assets/projectImages/primaxElectronicsImages/others/Primax Electronics-1.jpg';
import primaxElectronics2 from './assets/projectImages/primaxElectronicsImages/others/Primax Electronics-2.jpg';
import primaxElectronics3 from './assets/projectImages/primaxElectronicsImages/others/Primax Electronics-3.jpg';
import primaxElectronics4 from './assets/projectImages/primaxElectronicsImages/others/Primax Electronics-4.jpg';
import primaxElectronics5 from './assets/projectImages/primaxElectronicsImages/others/Primax Electronics-5.jpg';
import primaxElectronics6 from './assets/projectImages/primaxElectronicsImages/others/Primax Electronics-6.jpg';
import dreamsPhotography1 from './assets/projectImages/dreamsPhotographyImages/others/Dreams Photography-1.jpg';
import dreamsPhotography2 from './assets/projectImages/dreamsPhotographyImages/others/Dreams Photography-2.jpg';
import dreamsPhotography3 from './assets/projectImages/dreamsPhotographyImages/others/Dreams Photography-3.jpg';
import dreamsPhotography4 from './assets/projectImages/dreamsPhotographyImages/others/Dreams Photography-4.jpg';
import dreamsPhotography5 from './assets/projectImages/dreamsPhotographyImages/others/Dreams Photography-5.jpg';
import dreamsPhotography6 from './assets/projectImages/dreamsPhotographyImages/others/Dreams Photography-6.jpg';

const MyProfessionFieldsData = [
    {
        fieldName: 'Web Design',
        fieldDescription: 'I am able to design a small website. That website will be user-friendly and responsive. The appearance of the website will be standard as well as beautiful.',
        img: 'https://i.pinimg.com/originals/0e/76/a3/0e76a3bdb9a5f816879b8275dfd7238b.gif'
    },
    {
        fieldName: 'Frontend Development',
        fieldDescription: 'I am able to develop website from any web design. I can convert designs to a website application from a figma or other format of file.I can guarantee the transformation of the design to a website will be pixel perfect and also fully responsive.',
        img: 'https://miro.medium.com/max/1400/1*vJjJ3Mdok6Rvxx85IIRqBQ.gif'
    },
    {
        fieldName: 'Backend Development',
        fieldDescription: 'I can develop the backend of simple websites. In that case my preference technologies are Node.js and Express.js. As database I work with mongodb. For authentication, authorization I used json web token and firebase authentication.',
        img: 'https://c.tenor.com/2uyENRmiUt0AAAAC/coding.gif'
    },
    {
        fieldName: 'Full stack Developement',
        fieldDescription: 'I can make a design a of a user friendly responsive website that will look standred. Then I can develop frontend of that website. As well as I can develop the backend of simple websites with Node.js, Express, Mongodb, Firebase.',
        img: 'https://r7q6w9z6.rocketcdn.me/career/wp-content/uploads/2020/03/full-stack-development.gif'
    },
];

const skillCollectionsData = {
    comfortable: [
        { name: 'JavaScript', icon: JavaScriptIcon, skill: 70 },
        { name: 'NodeJS', icon: NodeIcon, skill: 50 },
        { name: 'HTML5', icon: HTMLIcon, skill: 80 },
        { name: 'CSS3', icon: CSSIcon, skill: 80 },
        { name: 'MongoDB', icon: MongoDBIcon, skill: 60 },
        { name: 'React', icon: ReactIcon, skill: 70 },
        { name: 'React Router', icon: ReactRouterIcon, skill: 70 },
        { name: 'Create React App', icon: CreateReactAppIcon, skill: 70 },
        { name: 'React Query', icon: ReactQueryIcon, skill: 60 },
        { name: 'React Hook Form', icon: ReactHookFormIcon, skill: 60 },
        { name: 'Tailwind CSS', icon: TailwindCSSIcon, skill: 80 },
        { name: 'Daisy UI', icon: DaisyUIIcon, skill: 80 },
        { name: 'Bootstrap', icon: BootstrapIcon, skill: 60 },
        { name: 'Material UI', icon: MaterialUIIcon, skill: 30 },
        { name: 'Express JS', icon: ExpressJSIcon, skill: 60 },
        { name: 'JWT', icon: JWTIcon, skill: 60 },
        { name: 'Npm', icon: NpmIcon, skill: 60 },
        { name: 'Git', icon: GitIcon, skill: 70 },
        { name: 'GitBash', icon: GitBashIcon, skill: 70 },
        { name: 'GitHub', icon: GitHubIcon, skill: 70 },
        { name: 'Firebase', icon: FirebaseIcon, skill: 70 },
    ],
    familiar: [
        { name: 'C', icon: CIcon, skill: 50 },
        { name: 'Java', icon: JavaIcon, skill: 30 },
        { name: 'Python', icon: PythonIcon, skill: 60 },
        { name: 'Typescript', icon: TypescriptIcon, skill: 50 },
        { name: 'Php', icon: PhpIcon, skill: 40 },
        { name: 'MySQL', icon: MySQLIcon, skill: 40 },
        { name: 'Firebase Storage', icon: FirebaseStorageIcon, skill: 40 },
        { name: 'Next JS', icon: NextJSIcon, skill: 30 },
        { name: 'React Native', icon: ReactNativeIcon, skill: 30 },
    ],
    tools: [
        { name: 'VsCode', icon: VsCodeIcon, skill: 80 },
        { name: 'Figma', icon: FigmaIcon, skill: 60 },
        { name: 'Chrome DevTools', icon: ChromeDevToolsIcon, skill: 70 },
        { name: 'Netlify', icon: NetlifyIcon, skill: 60 },
        { name: 'Heroku', icon: HerokuIcon, skill: 70 },
        { name: 'Microsoft Office', icon: MicrosoftOfficeIcon, skill: 70 },
        { name: 'Adobe Photoshop', icon: AdobePhotoshopIcon, skill: 60 },
        { name: 'Windows', icon: WindowsIcon, skill: 70 },
        { name: 'Flimora', icon: FlimoraIcon, skill: 70 }
    ],
};



const myProjectsData = [
    {
        id: 1,
        name: "Vertex Tools",
        time: 'May 2022 - June 2022',
        images: [vertexTools1, vertexTools2, vertexTools3, vertexTools4, vertexTools5, vertexTools6],
        liveLink: 'https://vertex-tools.web.app/',
        gitClient: 'https://github.com/ShahariarRahman/Vertex-Tools-Client-Side',
        gitServer: 'https://github.com/ShahariarRahman/Vertex-Tools-Server-Side',
        technologies: 'React, React Router, Date-fns, React-hook-form, React-query, Firebase, React,Firebase Hooks, Tailwind, Font Awesome, React Toastify, React-loader-spinner, MongoDB, Express, and more.',
        description: [
            'User authentication system with fully secure Admin, Customer authorization system implemented.',
            'Admin Access: Manage all admins, all products, and all orders, update profile and more.',
            'Customer Access: add reviews, order a product with payment method, update profile etc.'
        ],
    },
    {
        id: 2,
        name: "Primax Electronics",
        time: 'May 2022 - June 2022',
        images: [primaxElectronics1, primaxElectronics2, primaxElectronics3, primaxElectronics4, primaxElectronics5, primaxElectronics6],
        liveLink: 'https://primax-electronics.web.app/',
        gitClient: 'https://github.com/ShahariarRahman/Primax-Electronics-Client-Side',
        gitServer: 'https://github.com/ShahariarRahman/Primax-Electronics-Server-Side',
        technologies: 'React, React Router, Firebase, React Firebase Hooks, Tailwind, Font Awesome, React Toastify, Mongodb, Express, and more.',
        description: [
            'Suppliers store electronic products with detailed information of the product.',
            'Suppliers can update the quantity of a product also can delete a product.',
            'Suppliers are able to monitor the previously added products which were stored by them.'
        ],
    },
    {
        id: 3,
        name: "Dreams Photography",
        time: 'April 2022 - June 2022',
        images: [dreamsPhotography1, dreamsPhotography2, dreamsPhotography3, dreamsPhotography4, dreamsPhotography5, dreamsPhotography6],
        liveLink: 'https://dreams-photography-786.web.app/',
        gitClient: 'https://github.com/ShahariarRahman/Dreams-Photography',
        technologies: 'React, React Router, Firebase, React Firebase Hooks, Tailwind, Font Awesome, React Toastify, and more.',
        description: [
            'Firebase authentication system implemented.',
            'Customer has to login / register using email password or Google before purchasing package.',
            'Displayed all services offered by the photographer.'
        ],
    },
];



export { MyProfessionFieldsData as default, skillCollectionsData, myProjectsData };